/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: zXJ41ZVTz7ne

import * as React from "react";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "../../components/widgets/Dialog"; // plasmic-import: en2IIw2C3_aI/component
import DialogHeader from "../../components/widgets/DialogHeader"; // plasmic-import: 5TapYEMkYCfR/component
import IconButton from "../../components/widgets/IconButton"; // plasmic-import: LPry-TF4j22a/component
import { CopilotPromptInput } from "../../components/copilot/CopilotPromptInput"; // plasmic-import: pnV7KLVDUyoz/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_data_binding.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicCopilotChatDialog.module.css"; // plasmic-import: zXJ41ZVTz7ne/css

import SparklesSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__SparklesSvg"; // plasmic-import: 9Z0Cu-c5J/icon
import CloseIcon from "../plasmic_kit/PlasmicIcon__Close"; // plasmic-import: hy7vKrgdAZwW4/icon
import ChevronDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ChevronDownSvg"; // plasmic-import: xZrB9_0ir/icon
import ArrowDownSvgIcon from "../plasmic_kit_icons/icons/PlasmicIcon__ArrowDownSvg"; // plasmic-import: G2ToiXzCf/icon

createPlasmicElementProxy;

export type PlasmicCopilotChatDialog__VariantMembers = {};
export type PlasmicCopilotChatDialog__VariantsArgs = {};
type VariantPropType = keyof PlasmicCopilotChatDialog__VariantsArgs;
export const PlasmicCopilotChatDialog__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCopilotChatDialog__ArgsType = {};
type ArgPropType = keyof PlasmicCopilotChatDialog__ArgsType;
export const PlasmicCopilotChatDialog__ArgProps = new Array<ArgPropType>();

export type PlasmicCopilotChatDialog__OverridesType = {
  root?: Flex__<typeof Dialog>;
  dialogHeader?: Flex__<typeof DialogHeader>;
  text?: Flex__<"div">;
  closeBtn?: Flex__<typeof IconButton>;
  chatContent?: Flex__<"div">;
  scrollToBottomButton?: Flex__<typeof IconButton>;
  copilotPromptInput?: Flex__<typeof CopilotPromptInput>;
};

export interface DefaultCopilotChatDialogProps {
  className?: string;
}

const $$ = {};

function PlasmicCopilotChatDialog__RenderFunc(props: {
  variants: PlasmicCopilotChatDialog__VariantsArgs;
  args: PlasmicCopilotChatDialog__ArgsType;
  overrides: PlasmicCopilotChatDialog__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <Dialog
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames("__wab_instance", sty.root)}
      content={
        <React.Fragment>
          <div
            data-plasmic-name={"chatContent"}
            data-plasmic-override={overrides.chatContent}

            className={classNames("all", sty.chatContent)}
          />

          <div className={classNames("all", sty.freeBox__ajijo)}>
            <IconButton
              data-plasmic-name={"scrollToBottomButton"}
              data-plasmic-override={overrides.scrollToBottomButton}

              className={classNames("__wab_instance", sty.scrollToBottomButton)}
              shadow={"extraSmall"}
              size={"medium"}
              type={["round"]}
            >
              <ArrowDownSvgIcon
                className={classNames("all", sty.svg__crum7)}
                role={"img"}
              />
            </IconButton>
          </div>
        </React.Fragment>
      }
      footer={
        <div className={classNames("all", sty.freeBox__ecH)}>
          <CopilotPromptInput
            data-plasmic-name={"copilotPromptInput"}
            data-plasmic-override={overrides.copilotPromptInput}

            placeholder={"What can I build for you today?"}
          />
        </div>
      }
      header={
        <DialogHeader
          data-plasmic-name={"dialogHeader"}
          data-plasmic-override={overrides.dialogHeader}

          actions={
            <IconButton
              data-plasmic-name={"closeBtn"}
              data-plasmic-override={overrides.closeBtn}

              className={classNames("__wab_instance", sty.closeBtn)}
              withBackgroundHover={true}
            >
              <CloseIcon
                className={classNames("all", sty.svg__vnato)}
                role={"img"}
              />
            </IconButton>
          }
          grabbable={true}
          heading={
            <div className={classNames("all", sty.freeBox___3PZhd)}>
              <SparklesSvgIcon
                className={classNames("all", sty.svg__tbVrl)}
                role={"img"}
              />

              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}

                className={classNames("all", "__wab_text", sty.text)}
              >
                {"Plasmic AI"}
              </div>
            </div>
          }
          subheading={null}
        />
      }
      show={["header", "footer"]}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "dialogHeader",
    "text",
    "closeBtn",
    "chatContent",
    "scrollToBottomButton",
    "copilotPromptInput"
  ],
  dialogHeader: ["dialogHeader", "text", "closeBtn"],
  text: ["text"],
  closeBtn: ["closeBtn"],
  chatContent: ["chatContent"],
  scrollToBottomButton: ["scrollToBottomButton"],
  copilotPromptInput: ["copilotPromptInput"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof Dialog;
  dialogHeader: typeof DialogHeader;
  text: "div";
  closeBtn: typeof IconButton;
  chatContent: "div";
  scrollToBottomButton: typeof IconButton;
  copilotPromptInput: typeof CopilotPromptInput;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCopilotChatDialog__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCopilotChatDialog__VariantsArgs;
    args?: PlasmicCopilotChatDialog__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCopilotChatDialog__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCopilotChatDialog__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCopilotChatDialog__ArgProps,
          internalVariantPropNames: PlasmicCopilotChatDialog__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCopilotChatDialog__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCopilotChatDialog";
  } else {
    func.displayName = `PlasmicCopilotChatDialog.${nodeName}`;
  }
  return func;
}

export const PlasmicCopilotChatDialog = Object.assign(
  // Top-level PlasmicCopilotChatDialog renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dialogHeader: makeNodeComponent("dialogHeader"),
    text: makeNodeComponent("text"),
    closeBtn: makeNodeComponent("closeBtn"),
    chatContent: makeNodeComponent("chatContent"),
    scrollToBottomButton: makeNodeComponent("scrollToBottomButton"),
    copilotPromptInput: makeNodeComponent("copilotPromptInput"),

    // Metadata about props expected for PlasmicCopilotChatDialog
    internalVariantProps: PlasmicCopilotChatDialog__VariantProps,
    internalArgProps: PlasmicCopilotChatDialog__ArgProps
  }
);

export default PlasmicCopilotChatDialog;
/* prettier-ignore-end */
